/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { RoleBindingStatusPolicyID } from './role-binding-status-policy-id';

/**
 * RoleBindingStatus is the status of the role binding, reflecting the state of the related policies generation.
 * @export
 * @interface RoleBindingRoleBindingStatus
 */
export interface RoleBindingRoleBindingStatus {
    /**
     * Message is providing more information about the state.
     * @type {string}
     * @memberof RoleBindingRoleBindingStatus
     */
    'message'?: string;
    /**
     * Policies are the unique identifiers of the related policies.
     * @type {Array<RoleBindingStatusPolicyID>}
     * @memberof RoleBindingRoleBindingStatus
     */
    'policies'?: Array<RoleBindingStatusPolicyID>;
    /**
     * State is the state of the policies generation.
     * @type {string}
     * @memberof RoleBindingRoleBindingStatus
     */
    'state': RoleBindingRoleBindingStatusStateEnum;
    /**
     * UpdateTime is the timestamp when the role binding was last updated.
     * @type {string}
     * @memberof RoleBindingRoleBindingStatus
     */
    'updateTime'?: string;
}

export const RoleBindingRoleBindingStatusStateEnum = {
    UNSPECIFIED: 'POLICIES_STATE_UNSPECIFIED',
    ACCEPTED: 'POLICIES_STATE_ACCEPTED',
    CREATED: 'POLICIES_STATE_CREATED',
    FAILED: 'POLICIES_STATE_FAILED'
} as const;

export type RoleBindingRoleBindingStatusStateEnum = typeof RoleBindingRoleBindingStatusStateEnum[keyof typeof RoleBindingRoleBindingStatusStateEnum];


